<template>
  <md-dialog :md-active.sync="show" @md-clicked-outside="closeDialog" @md-closed="closeDialog">
    <div class="viewer-header">
      <md-button class="md-button md-just-icon md-simple"
                 @click="closeDialog">
        <i class="material-icons ">close</i>
      </md-button>
    </div>
    <div class="viewer-content">
      <div>
        <attachment-slider
          :initialSlideNumber="initialSlideNumber"
          :attachments="attachments"
        />
      </div>
    </div>

  </md-dialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AttachmentSlider from '@/components/Custom/AttachmentSlider';
  export default {
    name: "ImageViewerModal",
    data() {
      return {
        show: false,
      }
    },
    components: {
      AttachmentSlider,
    },
    mounted() {
      this.show = this.showImageViewer;
    },
    computed: {
      ...mapGetters([
        'imageViewerAttachments',
        'imageViewerInitSlideNumber',
        'showImageViewer',
      ]),

      attachments() {
        return this.imageViewerAttachments;
      },

      initialSlideNumber() {
        return this.imageViewerInitSlideNumber;
      }
    },
    methods: {
      closeDialog() {
        this.$store.dispatch('HIDE_IMAGE_VIEWER');
        this.$store.dispatch('SET_IMAGE_VIEWER_DATA', {
          attachments: null,
          initialSlideNumber: null,
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/md/_colors.scss";

  .md-dialog {
    width: 100%;
    max-width: 1024px;
  }

  .viewer-header {
    text-align: end;
    padding: 0 10px;
    border-bottom: 1px solid $grey-100;
  }
  .viewer-content {
    min-width: 420px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    background-color: $grey-50;
  }

</style>
